//@flow
import { AppContainer } from "./app-container";
import animation from "./animation";

export default { AppContainer, animation };